<template>
  <div class="cj-game-list-item-locked">
    <div class="container">
      <div class="lock" />

      <div class="sparkles">
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
      </div>
    </div>
  </div>
</template>

<script>
import { map } from 'ramda'
import { tween, styler, easing, stagger } from 'popmotion'

export default {
  name: 'CJGameListItemLocked',

  mounted () {
    const sparkles = this.$el.querySelectorAll('.sparkle')

    const sparklesStylers = map(styler, sparkles)

    stagger(map(sparkle => tween({
      from: { opacity: 0 },
      to: { opacity: 0.4 },
      ease: easing.easeOut,
      flip: Infinity,
      duration: 300,
    }), sparkles), 100)
      .start(vs => vs.forEach((v, idx) => sparklesStylers[idx].set(v)))
  },
}
</script>

<style lang="stylus" scoped>
  .cj-game-list-item-locked
    > .container
      position: relative

      > .lock
      > .sparkles
      > .sparkles > .sparkle
        position: absolute

      > .sparkles > .sparkle
        width: 8px
        height: 8px
        background-color: white
        border-radius: 50%
        opacity: 0

        &:nth-child(1)
          top: 4px
          left: 36px

        &:nth-child(2)
          top: 6px
          left: 47px

        &:nth-child(3)
          top: 11px
          left: 57px

        &:nth-child(4)
          top: 19px
          left: 64px

        &:nth-child(5)
          top: 29px
          left: 70px

        &:nth-child(6)
          top: 40px
          left: 72px

        &:nth-child(7)
          top: 51px
          left: 70px

        &:nth-child(8)
          top: 61px
          left: 65px

        &:nth-child(9)
          top: 69px
          left: 57px

        &:nth-child(10)
          top: 74px
          left: 47px

        &:nth-child(11)
          top: 76px
          left: 37px

        &:nth-child(12)
          top: 74px
          left: 26px

        &:nth-child(13)
          top: 69px
          left: 16px

        &:nth-child(14)
          top: 61px
          left: 8px

        &:nth-child(15)
          top: 51px
          left: 3px

        &:nth-child(16)
          top: 40px
          left: 1px

        &:nth-child(17)
          top: 29px
          left: 3px

        &:nth-child(18)
          top: 19px
          left: 7px

        &:nth-child(19)
          top: 11px
          left: 15px

        &:nth-child(20)
          top: 6px
          left: 25px
</style>
